import { Label } from '../../../../common/Label/Label';
import { classes } from '../../../../../lib/utils/cssUtils';
import styles from './CourseTile.module.scss';

export type CourseType = 'assigned' | 'completed' | 'in-progress' | 'overdue' | 'not-started';
export type CourseTileOrder = CourseType[];
export type SummaryItemsOrder = {
  summaryItemsOrder?: CourseTileOrder;
};

type CourseTileProps = {
  type: CourseType;
  labelKey: string;
  quantity: number;
  highlighted?: boolean;
};

const CourseTile = ({ type, labelKey, quantity, highlighted }: CourseTileProps) => {
  const id = `label-${type}`;

  const tileClass = classes(styles.course, styles[type], {
    [styles.highlighted]: highlighted,
  });

  return (
    <div className={tileClass}>
      <p id={id} className={styles.header}>
        <Label name={labelKey} />
      </p>
      <data aria-describedby={id} value={quantity} className={styles.quantity}>
        {quantity}
      </data>
    </div>
  );
};

export default CourseTile;
